import React from "react";
import { observer } from "mobx-react";
import { EditionDocumentationWorkflowStateViewStore } from "../../store";
import { EditionDocumentationWorkflowStateViewForm } from "./EditionDocumentationWorkflowStateViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type EditionDocumentationWorkflowStateViewProps = {
  editionDocumentationWorkflowStateViewStore: EditionDocumentationWorkflowStateViewStore;
};

export const EditionDocumentationWorkflowStateView: React.FC<EditionDocumentationWorkflowStateViewProps> =
  observer(({ editionDocumentationWorkflowStateViewStore }) => {
    return (
      <div>
        <EditionDocumentationWorkflowStateViewForm
          name_es={editionDocumentationWorkflowStateViewStore.name_esValue}
          name_en={editionDocumentationWorkflowStateViewStore.name_enValue}
          name_pt={editionDocumentationWorkflowStateViewStore.name_ptValue}
          onPrint={(handlePrint: () => void) =>
            editionDocumentationWorkflowStateViewStore.printEditionDocumentationWorkflowState(
              handlePrint
            )
          }
          onCancel={() =>
            editionDocumentationWorkflowStateViewStore.cancelEditionDocumentationWorkflowState()
          }
          onEdit={
            editionDocumentationWorkflowStateViewStore.isEditEnabled
              ? () =>
                  editionDocumentationWorkflowStateViewStore.editEditionDocumentationWorkflowState()
              : undefined
          }
        />
        <ErrorDialog
          open={editionDocumentationWorkflowStateViewStore.errorDialogOpened}
          title={editionDocumentationWorkflowStateViewStore.errorTitle}
          description={
            editionDocumentationWorkflowStateViewStore.errorDescription
          }
          onClose={() =>
            editionDocumentationWorkflowStateViewStore.closeErrorDialog()
          }
        />
      </div>
    );
  });
